import { useCallback, useMemo, useState } from 'react';
import { useAgreementFinancialsQuery } from './useAgreementFinancialsQuery';
import { futureScheduledCount, statementView as buildStatementView, visibleRows } from '../utils/statementRows';

export function useAgreementFinancials(id: string | undefined, active: boolean) {
    const query = useAgreementFinancialsQuery(id, active);
    const [toggle, setToggle] = useState<{ id: string | undefined; on: boolean }>({ id, on: false });
    if (toggle.id !== id) setToggle({ id, on: false });
    const showUnreconciled = toggle.id === id && toggle.on;
    const setShowUnreconciled = useCallback((on: boolean) => setToggle({ id, on }), [id]);
    const data = query.data;

    const statementView = useMemo(() => (data?.status === 'ok' ? buildStatementView(data) : null), [data]);
    const rows = useMemo(
        () => (statementView ? visibleRows(statementView.rows, statementView.asOf, showUnreconciled) : []),
        [statementView, showUnreconciled],
    );
    const futureCount = useMemo(
        () => (statementView ? futureScheduledCount(statementView.rows, statementView.asOf) : 0),
        [statementView],
    );

    return {
        isLoading: query.isLoading,
        isError: query.isError,
        notActivated: data?.status === 'not_activated',
        refetch: query.refetch,
        statementView,
        rows,
        futureCount,
        showUnreconciled,
        setShowUnreconciled,
        focusablePanel: !query.isError && (statementView === null || statementView.rows.length === 0),
    };
}
